export const iconFontAwesomeNatureSignsPost = (
	<i className="fa-solid fa-signs-post"></i>
);
